<nav class="navbar">
  <div class="navbar-logo NavFlexBox">
    <div><img alt="Company Logo" [src]="CompanyLogo" /></div>
    <div *ngIf="IsMobile">
      <a>
        <div class="GoHomeBtn" (click)="goHome()">
          <!-- Close -->
          <img src="../../../assets/images/img/x.svg" alt="" class="svg">
        </div>
      </a>
    </div>
  </div>
  <ul class="navbar-menu">
    <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <a routerLink="/privacy_policy">Privacy Policy</a>
    </li>
    <li routerLinkActive="active">
      <a routerLink="/terms">Terms & Conditions</a>
    </li>
    <li routerLinkActive="active">
      <a routerLink="/disclaimer">Disclaimer</a>
    </li>
    <li routerLinkActive="active">
      <a routerLink="/help_support">Help</a>
    </li>
    <li *ngIf="!IsMobile" >
      <a>
        <div class="GoHomeBtn" (click)="goHome()">
          <!-- Close -->
          <img src="../../assets/images/img/x.svg" alt="">
        </div>
      </a>
    </li>
  </ul>
</nav>
<router-outlet></router-outlet>